define('utils/image-scroll-slider', [
    'jquery',
    'underscore'
],  function ($, _) {
    'use strict';

    console.log('%cfile: image-scroll-slider.js', 'color: #C2ECFF');

    var imageScrollSlider = function imageScrollSlider(){
        console.log('%ctrace: imageScrollSlider', 'color: #ccc');

        var el = '[data-image-scroll-slider]';

        var $el = $(el);

        if($el.length <= 0){
            console.warn('%ctrace: imageScrollSlider: not found dom elements', 'color: #ccc');
            return false;
        }

        $el.each(function(i, el){
            initialize($(el));
        });

        function initialize($el){
            if($el.length <= 0){
                $el.attr('data-image-scroll-slider', 'left');
            }

            $el.off('click').on('click', function(e){
                e.preventDefault();

                var attr = $el.attr('data-image-scroll-slider');

                if(attr == 'left'){
                    $el.attr('data-image-scroll-slider', 'right');
                }else{
                    $el.attr('data-image-scroll-slider', 'left');
                }
            });
        }
    };

    return imageScrollSlider;
});
